<div
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    class="h-full flex flex-col">
    <div
        class="bg-primary-50 dark:bg-primary-800 flex flex-col gap-4 p-8 print:bg-transparent"
        [ngClass]="{ '!py-[15px] !px-6 bg-primary-100': slimHeader() }">
        <div class="flex">
            <h3
                class="h5 flex-1 m-0"
                [ngClass]="{ 'h6': slimHeader() }">
                <ng-content select="[title]"></ng-content>
            </h3>
            <big-ui-button
                [buttonStyle]="'tertiary icon [&>div]:min-h-0'"
                [id]="'close-overlay-icon'"
                (clicked)="closeModal.emit()"
                [title]="closeBtnTitle()"
                class="print:hidden">
                <big-icon
                    [icon]="iconClose"
                    [size]="'w-5'"
                    class="fill-current"
                    [attr.aria-label]="closeBtnTitle()" />
            </big-ui-button>
        </div>
        <ng-content select="[subtitle]"></ng-content>
    </div>
    <div
        class="flex-1 flex flex-col gap-8 p-8"
        [ngClass]="contentClass()">
        <div
            class="flex-1"
            [ngClass]="contentClass()">
            <ng-content select="[content]"></ng-content>
        </div>
        <ng-content
            class=""
            select="[buttonBar]"></ng-content>
    </div>
</div>
